import {CodeBlock} from "@/components/codeBlock/CodeBlock.tsx";

import styles from "./TracerouteRawOutput.module.scss";

// Raw traceroute text in the shared CodeBlock (bordered card + copy-to-clipboard).
// codeClassName keeps the monospace, whitespace-preserving presentation.
export const TracerouteRawOutput = ({text}: {text: string}) => (
  <CodeBlock code={text} codeClassName={styles.rawOutput} onModal />
);
